module.exports = __webpack_public_path__ + "img/css.08d32bd2.jpg";